import JoyField from '../types/JoyField';
import JoyUploadService from '../services/JoyUploadService';
import { isString, isStringArray } from '../validation/TypeChecking';
import { isJoyFieldMapArray, isJoyPropertiesArray, isJoyUploadSessionStatus, isJoyUploadSessionType, } from '../validation/ModelValidation';
export default class JoyUploadHelper {
    /**
     * Create a new upload session.
     * @param type The upload session type.
     * @param properties An array of JoyProperties.
     * @param assetCount Number of assets in the upload session, integer.
     * @param groupId The identifier of the group in which the medium documents will be placed, string.
     * @param albumId The identifier of the album the mediums belong to, string, optional.
     */
    static async createSession(type, properties, assetCount, groupId, albumId) {
        let data = new Map();
        data[JoyField.sessionType] = type;
        data[JoyField.props] = properties;
        data[JoyField.count] = assetCount;
        data[JoyField.group] = groupId;
        if (isString(albumId)) {
            data[JoyField.album] = albumId;
        }
        let result = await JoyUploadService.instance.createUploadSession(data);
        let id = result[JoyField.id];
        let mediumIds = [];
        if (isJoyFieldMapArray(result[JoyField.mediums])) {
            for (const mediumData of result[JoyField.mediums]) {
                if (isString(mediumData[JoyField.objectId])) {
                    mediumIds.push(mediumData[JoyField.objectId]);
                }
            }
        }
        if (isString(id) && isStringArray(mediumIds)) {
            return { id, mediumIds };
        }
        else {
            throw Error('Invalid input data for UploadSession');
        }
    }
    /**
     * Fetch an UploadSession.
     * @param id The identifier of the session to fetch.
     */
    static async getSession(id) {
        let result = await JoyUploadService.instance.getUploadSession(id);
        let props = result[JoyField.props];
        let status = result[JoyField.status];
        let type = result[JoyField.sessionType];
        if (isJoyPropertiesArray(props) && isJoyUploadSessionStatus(status) && isJoyUploadSessionType(type)) {
            return { props, status, type };
        }
        else {
            throw Error('Invalid data for UploadSession');
        }
    }
    /**
     * Fetch upload sessions.
     * @param statusFilter An array of UploadSessionStatus values.
     */
    static getSessions(statusFilter) {
        let data = new Map();
        data[JoyField.status] = statusFilter;
        return JoyUploadService.instance.getUploadSessions(data);
    }
    /**
     * Add more assets to an existing upload session.
     * @param assetCount Number of assets to add, integer.
     */
    static async addToSession(id, assetCount) {
        let data = new Map();
        data[JoyField.id] = id;
        data[JoyField.count] = assetCount;
        let result = await JoyUploadService.instance.addToUploadSession(data);
        let mediumIds = [];
        if (isJoyFieldMapArray(result[JoyField.mediums])) {
            for (const mediumData of result[JoyField.mediums]) {
                if (isString(mediumData[JoyField.objectId])) {
                    mediumIds.push(mediumData[JoyField.objectId]);
                }
            }
        }
        if (isStringArray(mediumIds)) {
            return mediumIds;
        }
        else {
            throw Error('Invalid input data for UploadSession');
        }
    }
    /**
     * End an UploadSession.
     * @param id The identifier of the upload session string.
     */
    static async closeSession(id) {
        await JoyUploadService.instance.closeUploadSession(id);
        return true;
    }
}
//# sourceMappingURL=JoyUploadHelper.js.map